import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../utils/api';

const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      loading: false,

      isLogado: () => !!get().token,

      setAuth: (token, user) => {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        set({ token, user });
      },

      logout: () => {
        delete api.defaults.headers.common['Authorization'];
        set({ token: null, user: null });
      },

      login: async (email, senha) => {
        set({ loading: true });
        try {
          const { data } = await api.post('/auth/login', { email, senha });
          api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          set({ token: data.token, user: data.usuario, loading: false });
          // Retorna formato esperado pelo Login.jsx (success + tipo) E pelo authStore interno (ok)
          return { ok: true, success: true, tipo: data.usuario?.tipo };
        } catch (err) {
          set({ loading: false });
          const msg = err.response?.data?.erro || 'E-mail ou senha incorretos.';
          return { ok: false, success: false, erro: msg, msg };
        }
      },

      cadastrarCandidato: async (dados) => {
        set({ loading: true });
        try {
          const { data } = await api.post('/auth/cadastro/candidato', dados);
          api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          set({ token: data.token, user: data.usuario, loading: false });
          return { ok: true };
        } catch (err) {
          set({ loading: false });
          return { ok: false, msg: err.response?.data?.erro || 'Erro ao cadastrar.' };
        }
      },

      cadastrarEmpresa: async (dados) => {
        set({ loading: true });
        try {
          const { data } = await api.post('/auth/cadastro/empresa', dados);
          api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          set({ token: data.token, user: data.usuario, loading: false });
          return { ok: true };
        } catch (err) {
          set({ loading: false });
          return { ok: false, msg: err.response?.data?.erro || 'Erro ao cadastrar.' };
        }
      },

      recarregarUser: async () => {
        try {
          const { data } = await api.get('/auth/me');
          set({ user: data.usuario });
        } catch {
          get().logout();
        }
      },

      atualizarUser: (novosDados) => {
        set(state => ({ user: { ...state.user, ...novosDados } }));
      },
    }),
    {
      name: 'acrejob-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);

export default useAuthStore;
